import styled from '@emotion/styled'
import darken from 'polished/lib/color/darken'

import { breakpoints, colors, palette, spacing } from 'main/ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.md}px) {
    flex-direction: row;
  }
`

export const ValuePropositionContainer = styled.div`
  background-color: ${palette.indigo};
  margin: 0 -${spacing.majorScale(4)}px;

  @media (min-width: ${breakpoints.md}px) {
    background-color: ${darken(0.05, palette.indigo)};
    margin: 0 0 -${spacing.majorScale(4)}px -${spacing.majorScale(4)}px;
    flex: 5;
  }

  @media (min-width: ${breakpoints.lg}px) {
    margin: 0 0 -${spacing.majorScale(6)}px -${spacing.majorScale(6)}px;
  }
`

export const JoinFormContainer = styled.div`
  border-top: 1px solid ${colors.border.default};
  margin: 0 -${spacing.majorScale(4)}px;
  padding: ${spacing.majorScale(4)}px;

  @media (min-width: ${breakpoints.md}px) {
    margin: 0 -${spacing.majorScale(4)}px -${spacing.majorScale(4)}px 0;
    flex: 4;
  }

  @media (min-width: ${breakpoints.lg}px) {
    margin: 0 -${spacing.majorScale(6)}px -${spacing.majorScale(6)}px 0;
  }
`

export const LinkContainer = styled.div`
  padding: 0 ${spacing.majorScale(2)}px ${spacing.majorScale(2)}px;
  text-align: center;
`

export const RemoveCtaContainer = styled.div`
  margin-top: ${spacing.majorScale(2)}px;
`
